import { Base } from "ui/Scripts/source/framework/base";
import { IUnitItem, UnitItem } from "../unit/unitItem";
import { ITaskListItem, TaskListItem } from "./taskListItem";
import { ITaskStateItem, TaskStateItem } from "./taskStateItem";

export interface ITaskList {
    hasMore: boolean;
    page: number;
    items: ITaskListItem[];
    sortColumn: string;
    units: IUnitItem[];
    taskStates: ITaskStateItem[];
    canCreateTasks: boolean;
}

export class TaskList implements ITaskList {
    hasMore: boolean;
    page: number;
    items: TaskListItem[];
    sortColumn: string;
    units: UnitItem[];
    taskStates: TaskStateItem[];
    canCreateTasks: boolean;

    constructor();
    constructor(obj: ITaskList);
    constructor(obj?: any) {
        this.hasMore = obj && obj.hasMore || false;
        this.page = obj && obj.page || 1;
        this.sortColumn = obj && obj.sortColumn || "";
        this.items = Base.getTypedArray<TaskListItem>(obj ? obj.items : null, TaskListItem);
        this.units = Base.getTypedArray<UnitItem>(obj ? obj.units : null, UnitItem);
        this.taskStates = Base.getTypedArray<TaskStateItem>(obj ? obj.taskStates : null, TaskStateItem);
        this.canCreateTasks = obj && obj.canCreateTasks || false;
    }
}